<template>
    <div class="guanjiaDia">
        <el-dialog :visible.sync="dialogVisible" width="30%" :modal-append-to-body="false">
            <div slot="title" class="header-title">
                <h2>免费咨询猿派经理人</h2>
            </div>
            <div class="main">
                <div class="msg">
                    我们很乐意回答任何问题，只需扫码添加
                </div>

                <div class="code-box">
                    <img :src="imgSrc" alt="">
                    <div class="code-msg">微信扫码</div>
                    <div class="code-tip">
                        我们会有专人一对一的为您解决问题。
                    </div>
                </div>

                <h3>通过其他渠道找到我们</h3>

                <div class="lianxi">
                    <span>yuanpai@itjob365.com</span>
                    <div class="line"></div>
                    <span>400-801-0332</span>
                </div>

                <el-button type="primary" @click="dialogVisible = false">添加完成</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import qs from 'qs'
export default {
    data() {
        return {
            dialogVisible: false,
            imgSrc: ''
        };
    },
    created() {
        let guanjia = localStorage.getItem("guanjia")
        guanjia ? (this.imgSrc = JSON.parse(guanjia).name) : this.getGuanjia()
    },
    methods: {
        getGuanjia() {
            window.fdGlobal
                .ajax({
                    method: "POST",
                    url: window.fdConfig.url.rsgl("getGuanjia"),
                    // URL参数
                    // 必须是一个纯对象或者 URL参数对象
                    headers: {
                        "content-type": "application/x-www-form-urlencoded",
                        type: "reward"
                    },
                    data: qs.stringify({ }),
                    //params: '',
                    // 默认值是json
                    responseType: "json"
                })
                .then(
                    data => {
                        if (data.data.code == 1) {
                            this.imgSrc = data.data.data.name
                            localStorage.setItem("guanjia",JSON.stringify(data.data.data))
                        } else {
                            // this.$message.warning(data.data.message);
                        }
                    },
                    data => {
                        // this.$message.warning(data.data.message);
                    }
                );
        },
    }
}
</script>

<style lang="less" scoped>
.guanjiaDia {
    .header-title {
        font-size: 16px;
    }

    .main {
        .msg {
            font-size: 14px;
            color: #4E5969;
        }

        .code-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            margin: 24px 0;
            background: #F7F8FA;
            border-radius: 12px;
            padding: 24px 0;

            img {
                width: 180px;
                height: 180px;
            }

            .code-msg {
                margin: 8px 0 6px;
                color: #1D2129;
                font-size: 14px;
                font-weight: 500;
            }

            .code-tip {
                font-size: 13px;
                color: #86909C;
            }
        }

        h3 {
            text-align: center;
            color: #4CD263;
            font-size: 16px;
            margin-bottom: 12px;
        }

        .lianxi {
            display: flex;
            align-items: center;
            justify-content: space-around;
            padding: 0 24px;
            margin-bottom: 28px;

            .line {
                width: 2px;
                height: 12px;
                background-color: #E5E6EB;
            }
        }

        .el-button {
            width: 100%;
            background: #165DFF !important;
            border: none;
            color: #fff;
            border-radius: 8px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/guanjiaDia/guanjiaDia.vue